import styles from './sass/index.scss';
import normalize from 'normalize.css';
import font from './fonts/7stroke/pe-icon-7-stroke/css/pe-icon-7-stroke.css';

import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import AdminApp from './AdminApp';
import ChatApp from './ChatApp';
import Store from './redux/stores/store';
import { DEFAULT_LOCALE, initLocale} from './locales';

const livechatId = (window.location.pathname.replace('/', '')) || (window.location.hash.replace('#', '')) || 1; // eslint-disable-line no-undef
const serverUrl = process.env.SERVER_URL;

console.log('*** DEFAULT LOCALE ***', DEFAULT_LOCALE);

initLocale('en').then(() => {
  render(
    <Provider store={Store}>
      {
        (() => {
          if (livechatId === 'admin') {
            return <AdminApp serverUrl={serverUrl} />;
          }
  
          return (
            <ChatApp
              livechatId={parseInt(livechatId, 10)}
              serverUrl={serverUrl}
            />
          );
        })()
      }
    </Provider>,
    document.getElementById('app'), // eslint-disable-line no-undef
  );
});


// WEBPACK FOOTER //
// ./src/index.jsx